module.exports = __webpack_public_path__ + "media/images/city/069-great-mosque-of-samarra-2671dbbf9b26df58dc0c2d6fedf8e880.svg";